export enum ConfirmationChannelEnum {
	SMS = 'sms',
	EMAIL = 'email'
}
